import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Logo, FireButton } from "@/components/fx";
import { useAuth } from "@/context/AuthContext";
import { Hero } from "@/components/landing/Hero";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Bento, WhatItBuilds, Compare } from "@/components/landing/Sections";
import { Differentiators } from "@/components/landing/Differentiators";
import { ProductPreview, Pricing, Faq, FinalCta, Footer } from "@/components/landing/More";

const Nav = () => {
  const { user } = useAuth();
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const f = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", f, { passive: true });
    return () => window.removeEventListener("scroll", f);
  }, []);
  return (
    <nav data-testid="landing-nav" className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${scrolled ? "glass-strong" : ""}`}>
      <div className="mx-auto flex max-w-7xl items-center gap-8 px-6 py-4">
        <Logo />
        <div className="hidden gap-6 text-sm text-white/60 md:flex">
          <a href="#how" className="hover:text-white">How it works</a>
          <a href="#why" className="hover:text-white">Why FORGE</a>
          <a href="#builds" className="hover:text-white">What it builds</a>
          <a href="#pricing" className="hover:text-white">Pricing</a>
        </div>
        <div className="ml-auto flex items-center gap-3">
          {user ? (
            <FireButton as={Link} to="/app" data-testid="nav-open-app" className="px-5 py-2 text-sm">Open FORGE</FireButton>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login" className="text-sm text-white/70 hover:text-white">Log in</Link>
              <FireButton as={Link} to="/signup" data-testid="nav-signup" className="px-5 py-2 text-sm">Start building</FireButton>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default function Landing() {
  return (
    <div data-testid="landing-page" className="relative min-h-screen overflow-x-hidden bg-[#07060b]">
      <Nav />
      <Hero />
      <HowItWorks />
      <Bento />
      <Differentiators />
      <WhatItBuilds />
      <ProductPreview />
      <Compare />
      <Pricing />
      <Faq />
      <FinalCta />
      <Footer />
    </div>
  );
}
